import CommonSetting from '@/class/CommonSetting'
export default new CommonSetting()
